import { useEffect, useRef, useState } from "react";
import { Button, Col, Container } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { ParametrosAPI } from "../../../../shared/http-requests";
import { APIHelper } from "../../../../shared/helpers";


function AutoAtendimento({instituicaoRx}) {

    const [showAutoatendimento, setShowAutoatendimento] = useState(false);
    const { t } = useTranslation();
    const [codBibAuto, setCodBibAuto] = useState(0)
    const [idiomaAuto, setIdiomaAuto] = useState(0);
    const [authAuto, setAuthAuto] = useState('');
    const alreadyMadeReq = useRef(false);

    useEffect(() => {
        if (alreadyMadeReq.current) return;

        alreadyMadeReq.current = true;

        ParametrosAPI.validaAutoatendimento()
            .then(response => {
                setShowAutoatendimento(response.data.showAuto);
                setCodBibAuto(response.data.codBibAuto);
                setAuthAuto(response.data.authAuto);
                setIdiomaAuto(response.data.idiomaAuto);
            })
            .catch(error => APIHelper.tratarErro(error));
    }, []);
          return  <Container>
                {showAutoatendimento ? (
                                        <Col xs="12" className="text-center d-none d-md-block">
                                            <div style={{ position: 'absolute', top: '-5px',zIndex: '1000',borderRadius: "0 0 24px 24px" }} class="bklight70 d-inline-block mt-1 p-2">
                                            <Button
                                                className="btn-generic--primeiro ml-0"
                                                onClick={() => {
                                                    window.open(
                                                        `
                                                        ${instituicaoRx.p.__web_url_pw}home_geral/login_auto_atendimento.jsp?empresa=${instituicaoRx.codEmpresa}&biblioteca=${codBibAuto}&idioma=${idiomaAuto}&permissao_teclado_numerico=false&tipoAutenticacao=${authAuto}`,
                                                        'ControlWindow',
                                                        `width=${screen.width - 8},height=${
                                                            screen.height - 75
                                                        },top=0px,left=0px,status=yes,scrollbars=yes,resizable=yes`,
                                                    );
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={['fas', 'user-cog']}
                                                    className="s18"
                                                />{' '}
                                                {t('Autoatendimento')}
                                            </Button>
                                            </div>
                                        </Col>
                         ) : null}
          </Container>
    
};

const mapStateToProps = state => ({
    acessibilidadeRx: state.pageConfig.acessibilidade,
    instituicaoRx: state.instituicao.data,
});

export default connect(mapStateToProps)(withRouter(AutoAtendimento));